import Vue from 'vue'
import Router from 'vue-router'

import Index from '../page/index/index'

//FAQ
import Help from '../page/FAQ/help';
import Equipment from '../page/FAQ/equipment';
import Content from '../page/FAQ/content';
import Equi_home from '../page/FAQ/equi_home'

//PC游戏详情分享页
import SharePage from '../page/community/shareDetail';

//PC端faq
import Instruct from '../page/faqPC/index.vue';
import Device from '../page/faqPC/device.vue';
import FaqContent from '../page/faqPC/content.vue';

//重构说游
//import Saygame from '../page/saygame/index.vue';

Vue.use(Router)

export default new Router({
	hashbang: true,
  routes: [
    {
      path: '/',
			name: 'index',
			component: Index
    },
    {
      path: '/help',
			name: 'help',
			component: Help
    },
    {
      path: '/equipment/:id',
			name: 'equipment',
			component: Equipment
    },
    {
      path: '/content/:id',
			name: 'content',
			component: Content
    },
    {
      path: '/equiHome/:id',
			name: 'equiHome',
			component: Equi_home
    },
    {
      path: '/shareDetail/:id',
			name: 'shareDetail',
			component: SharePage
    },
    {
      	path: '/instruct',
		name: 'instruct',
		component: Instruct
    },
    {
      	path: '/device/:id/:keyId',
		name: 'device',
		component: Device
    },
    {
      	path: '/faqContent/:id',
		name: 'faqContent',
		component: FaqContent
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js